
<style>
  .edit-invoicegroup-popup {
    padding: 10px 15px 0 !important;
    border-radius: 4px;
    padding-bottom: 0 !important;
    height: auto;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
  }

  .edit-invoicegroup-popup .time-row,
  .edit-invoicegroup-popup .text-input {
    font-size: 16px;
    margin-left: 0px !important;
    margin-bottom: 15px;
    padding: 12px 12px 8px;
    border: 0;
    border-bottom: 1px solid #6f6f6f;
    border-radius: 4px 4px 0 0;
    background-color: #f2f2f2;
    height: 48px;
    box-sizing: border-box;
  }
  
  .edit-invoicegroup-popup .text-input.amount {
    width: 100%;
  }

  :host ::ng-deep .invoice-calendar-dialog .mat-dialog-container,
  :host ::ng-deep .invoice-calendar-dialog .mat-mdc-dialog-container .mat-mdc-dialog-surface {
    padding: 15px 5px !important;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  :host ::ng-deep .invoice-calendar-dialog .mat-mdc-dialog-surface,
  :host ::ng-deep .invoice-calendar-dialog .mat-dialog-container {
    display: block;
    height: auto;
    max-height: 90vh;
  }

  :host ::ng-deep .invoice-calendar-dialog .mat-mdc-dialog-component-host {
    display: block;
    height: auto;
  }

  .mat-dialog-content,
  .mat-mdc-dialog-content {
     max-height: none;
     padding-bottom: 0 !important;
     overflow-y: visible;
     overflow-x: hidden;
  }

  .edit-invoicegroup-popup .row {
    margin-left: 0;
    margin-right: 0;
  }

  .edit-invoicegroup-popup .mat-form-field-label {
    margin-left: 10px !important;
  }

  .edit-invoicegroup-popup textarea:focus,
  .edit-invoicegroup-popup input:focus {
    caret-color: black;
  }

  /*::ng-deep .mat-form-field-underline {
    display: none;
  }*/

  .edit-invoicegroup-popup textarea {
    margin-bottom: 0px;
  }

  .amount {
    height: 48px;
    margin-top: 0px;
  }
  .delete_button {
    float: right;
    cursor: pointer;
  }

  .time-col {
    padding-top:5px;
    display: inline;
    margin-left: 5px;
  }

  .time-input
  {
    width: 70px;
  }

  .edit-invoicegroup-popup mat-select.select-hours,
  .edit-invoicegroup-popup mat-select.select-vat,
  .edit-invoicegroup-popup mat-select.select-time-report-status {
    padding: 12px 12px 8px !important;
    border: 0 !important;
    border-bottom: 1px solid #6f6f6f !important;
    border-radius: 4px 4px 0 0;
    background-color: #f2f2f2;
    height: 48px;
  }

  .edit-invoicegroup-popup .mat-form-field-type-mat-input .mat-form-field-flex,
  .edit-invoicegroup-popup .mat-form-field-type-mat-textarea .mat-form-field-flex {
    background-color: #f2f2f2;
    border-radius: 4px 4px 0 0;
    padding: 0.2em 0.75em 0;
  }

  .edit-invoicegroup-popup .mat-form-field-type-mat-input .mat-form-field-infix,
  .edit-invoicegroup-popup .mat-form-field-type-mat-textarea .mat-form-field-infix {
    border-top: 0;
    padding: 0.6em 0 0.4em;
  }

  .edit-invoicegroup-popup .mat-form-field-type-mat-input .mat-form-field-underline,
  .edit-invoicegroup-popup .mat-form-field-type-mat-textarea .mat-form-field-underline {
    background-color: #6f6f6f;
  }

  .edit-invoicegroup-popup .calendar-wrapper {
    background: #fafafa;
    border: 1px solid #ececec;
    border-radius: 4px;
    padding: 6px 15px;
    max-width: 100%;
    margin-left: 0;
    align-self: flex-start;
    height: fit-content;
  }

  .edit-invoicegroup-popup .tax-row {
    align-items: flex-start;
  }

  :host ::ng-deep .edit-invoicegroup-popup .calendar-wrapper .mat-calendar {
    transform: scale(0.9);
    transform-origin: top left;
    width: 100%;
  }

  .edit-invoicegroup-popup .pending-time-row {
    border-bottom: 1px solid #ececec;
    border-radius: 0;
    padding: 0 4px;
    margin-bottom: 2px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
  }

  .edit-invoicegroup-popup .pending-time-date {
    font-weight: 600;
    min-width: 90px;
  }

  .edit-invoicegroup-popup .pending-time-inputs {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
  }

  .edit-invoicegroup-popup .pending-time-inputs .time-select {
    max-width: 84px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-wrapper {
    padding-bottom: 0;
    margin: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-flex {
    padding: 0 2px;
    min-height: 18px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-infix {
    padding: 0 !important;
    min-height: 0 !important;
    height: auto !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field-subscript-wrapper,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-subscript-wrapper {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-select-trigger {
    padding: 0 !important;
    line-height: 1 !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-select-value {
    padding: 0 !important;
    line-height: 1 !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field-infix,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-infix {
    min-height: 0 !important;
    height: 24px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    line-height: 24px !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field {
    height: 30px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mdc-text-field {
    height: 30px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-select-trigger {
    height: 30px;
    align-items: center;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-select-value-text {
    line-height: 26px;
    transform: translateY(-1px);
  }

  .edit-invoicegroup-popup .pending-time-inputs button.mat-icon-button {
    width: 24px;
    height: 24px;
    line-height: 24px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-icon-button,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-icon-button .mat-icon,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-icon-button .mat-icon {
    position: relative !important;
    top: 3px !important;
    transform: translateY(-3px);
  }

  .edit-invoicegroup-popup .pending-time-inputs button.mat-icon-button .mat-icon {
    font-size: 14px;
    line-height: 14px;
  }

  @media only screen and (max-width: 768px) {
    .edit-invoicegroup-popup .pending-time-row {
      flex-wrap: wrap;
    }
  }

  @media only screen and (max-width: 992px) {
    .edit-invoicegroup-popup .tax-row > [class*='col-'] {
      flex: 0 0 100%;
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    }

    .edit-invoicegroup-popup .reverse-tax-col {
      margin-top: 8px;
      margin-bottom: 8px !important;
    }
  }

  .edit-invoicegroup-popup .text-input.full-width {
    width: 100%;
    display: block;
  }

  .edit-invoicegroup-popup .reverse-tax-col {
    display: flex;
    align-items: flex-end;
    min-width: 0;
    padding-left: 0;
  }

  .edit-invoicegroup-popup .vat-col {
    padding-right: 0;
  }

  .edit-invoicegroup-popup .tax-row > [class*='col-'] {
    min-width: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .reverse-tax-col .mat-checkbox-layout,
  :host ::ng-deep .edit-invoicegroup-popup .reverse-tax-col .mat-checkbox-label {
    white-space: normal;
    align-items: flex-start;
  }

  .edit-invoicegroup-popup .actions-row {
    margin-top: 16px;
    clear: both;
  }

  .edit-invoicegroup-popup .dialog-actions-row {
    margin-top: 8px;
  }

  .edit-invoicegroup-popup .error-message {
    display: block;
    margin: 6px 0 10px;
    line-height: 1.3;
    width: 100%;
    clear: both;
  }

  .edit-invoicegroup-popup .working-title-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }

  .edit-invoicegroup-popup .working-title-row {
    display: block;
    margin-bottom: 16px;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 0 15px;
    margin: 0;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields .half-width-top-field {
    float: none;
    flex: 1 1 calc(50% - 8px);
    width: auto;
    padding-right: 0;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields .second-row {
    clear: none;
  }

  .edit-invoicegroup-popup .half-width-top-field {
    display: block;
    float: left;
    width: 50%;
    vertical-align: top;
    padding-right: 15px;
  }

  .edit-invoicegroup-popup .half-width-top-field.second-row {
    display: block;
    clear: both;
  }

  .edit-invoicegroup-popup .tax-row {
    clear: both;
  }

  @media (max-width: 767.98px) {
    .edit-invoicegroup-popup .half-width-top-field {
      display: block;
      float: none;
      width: 100%;
      padding-right: 0;
    }
  }

  .edit-invoicegroup-popup .working-title-error-row {
    margin-top: -6px;
    margin-bottom: 16px;
  }

  .edit-invoicegroup-popup .actions-row {
    clear: both;
    margin-top: 16px;
    justify-content: flex-end;
  }

  .edit-invoicegroup-popup .working-title-field .text-input {
    margin-bottom: 0;
  }

  .edit-invoicegroup-popup .actions-row {
    margin-top: 16px;
    justify-content: flex-end;
  }

  .edit-invoicegroup-popup .actions-row .col-lg-12 {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .edit-invoicegroup-popup .save-button-disabled {
    pointer-events: none;
    opacity: 0.65;
  }

  /* Component styling follows Documentation/AI/06-frontend-design-rules.md. */
  .edit-invoicegroup-popup {
    width: 100%;
    padding: 30px 34px 24px !important;
    color: #111827;
    font-size: 13px;
  }

  :host ::ng-deep .invoice-calendar-dialog .mat-dialog-container,
  :host ::ng-deep .invoice-calendar-dialog .mat-mdc-dialog-container .mat-mdc-dialog-surface {
    padding: 0 !important;
    border: 1px solid #dfe4ec;
    border-radius: 9px;
    background: #ffffff;
  }

  .edit-invoicegroup-popup .description-row {
    margin-bottom: 24px;
  }

  .edit-invoicegroup-popup .financial-fields {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) minmax(140px, 180px) minmax(280px, 1.25fr);
    align-items: center;
    gap: 16px;
    margin: 0;
  }

  .edit-invoicegroup-popup .financial-field,
  .edit-invoicegroup-popup .financial-field mat-form-field {
    width: 100%;
    min-width: 0;
  }

  .edit-invoicegroup-popup .reverse-tax-col {
    align-items: center;
    align-self: stretch;
    margin: 0 !important;
    padding: 0;
    font-size: 13px;
  }

  :host ::ng-deep .edit-invoicegroup-popup mat-form-field {
    font-size: 13px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-wrapper {
    margin: 0;
    padding-bottom: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-appearance-fill .mat-form-field-flex,
  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-appearance-outline .mat-form-field-flex {
    min-height: 56px;
    align-items: center;
    padding: 0 12px;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field.mat-form-field-appearance-fill .mat-mdc-text-field-wrapper,
  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper {
    min-height: 56px;
    padding: 0 12px;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-appearance-outline .mat-form-field-outline,
  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-appearance-fill .mat-form-field-underline,
  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field .mdc-line-ripple,
  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field-focus-overlay {
    display: none;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mdc-notched-outline__leading,
  :host ::ng-deep .edit-invoicegroup-popup .mdc-notched-outline__notch,
  :host ::ng-deep .edit-invoicegroup-popup .mdc-notched-outline__trailing {
    border-color: transparent !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-infix {
    min-height: 56px;
    padding: 20px 0 6px;
    border-top: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field-infix {
    min-height: 56px;
    padding-top: 20px;
    padding-bottom: 6px;
  }

  :host ::ng-deep .edit-invoicegroup-popup textarea.mat-input-element,
  :host ::ng-deep .edit-invoicegroup-popup textarea.mat-mdc-input-element {
    min-height: 72px;
    margin: 0;
    resize: vertical;
  }

  :host ::ng-deep .edit-invoicegroup-popup .mat-form-field-disabled .mat-form-field-flex,
  :host ::ng-deep .edit-invoicegroup-popup .mat-mdc-form-field.mat-form-field-disabled .mat-mdc-text-field-wrapper {
    border-color: #e5e9f0;
    background: var(--sam-input-background, #f7f7f7);
  }

  .edit-invoicegroup-popup .actions-row {
    margin-top: 30px;
  }

  .edit-invoicegroup-popup .actions-row .col-lg-12 {
    display: grid;
    grid-template-columns: minmax(140px, 0.7fr) minmax(180px, 1fr) minmax(180px, 1fr);
    gap: 8px;
    padding: 0;
  }

  .edit-invoicegroup-popup .actions-row button {
    width: 100%;
    height: 44px !important;
    min-height: 44px;
    margin: 0;
    padding: 0 18px;
    border-radius: 7px;
    font-size: 14px;
  }

  @media (max-width: 767.98px) {
    .edit-invoicegroup-popup {
      padding: 22px 20px 20px !important;
    }

    .edit-invoicegroup-popup .financial-fields,
    .edit-invoicegroup-popup .actions-row .col-lg-12 {
      grid-template-columns: 1fr;
    }

    .edit-invoicegroup-popup .reverse-tax-col {
      min-height: 44px;
    }
  }

  /* Worked-hours view: compact label-free controls and stable repeated rows. */
  .edit-invoicegroup-popup .worked-hours-top-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 16px;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields .half-width-top-field {
    width: auto;
    min-width: 0;
    margin: 0 !important;
    padding: 0;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields .second-row {
    grid-column: 1 / -1;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields h5 {
    margin: 0 0 8px;
    color: #111827;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.3;
  }

  .edit-invoicegroup-popup .worked-hours-top-fields .text-input,
  .edit-invoicegroup-popup .worked-hours-top-fields mat-select.select-hours {
    display: flex;
    width: 100%;
    min-height: 48px;
    height: 48px;
    align-items: center;
    margin: 0 !important;
    padding: 0 12px !important;
    border: 1px solid #dfe4ec !important;
    border-radius: 7px !important;
    color: #111827;
    background: var(--sam-input-background, #f7f7f7);
    box-sizing: border-box;
    font-size: 13px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .worked-hours-top-fields .mat-select-trigger,
  :host ::ng-deep .edit-invoicegroup-popup .worked-hours-top-fields .mat-mdc-select-trigger {
    display: flex;
    height: 46px;
    align-items: center;
  }

  .edit-invoicegroup-popup .tax-row {
    display: grid;
    grid-template-columns: minmax(320px, 1.1fr) minmax(360px, 1fr);
    align-items: start;
    gap: 16px;
    margin: 0;
  }

  .edit-invoicegroup-popup .tax-row > [class*='col-'] {
    width: auto;
    max-width: none;
    min-width: 0;
    padding: 0;
  }

  .edit-invoicegroup-popup .calendar-wrapper {
    width: 100%;
    margin: 0;
    padding: 16px;
    border: 1px solid #dfe4ec;
    border-radius: 9px;
    background: #fbfcfe;
  }

  .edit-invoicegroup-popup .pending-time-row {
    min-height: 58px;
    margin: 0;
    padding: 5px 4px;
    border-bottom: 1px solid #eef0f5;
    box-sizing: border-box;
    gap: 8px;
  }

  .edit-invoicegroup-popup .pending-time-inputs {
    min-height: 48px;
    gap: 8px;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs mat-form-field,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field {
    width: 84px;
    height: 48px !important;
    min-height: 48px !important;
    margin: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-wrapper,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field-subscript-wrapper {
    height: 48px;
    margin: 0;
    padding: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-flex,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-text-field-wrapper {
    min-height: 48px !important;
    height: 48px !important;
    align-items: center;
    padding: 0 10px !important;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
    box-sizing: border-box;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-form-field-infix,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-form-field-infix {
    display: flex;
    min-height: 46px !important;
    height: 46px !important;
    align-items: center;
    padding: 0 !important;
    border: 0;
    line-height: normal !important;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-select-trigger,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-select-trigger {
    display: flex;
    height: 46px !important;
    align-items: center;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-select-value,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs .mat-mdc-select-value-text {
    padding: 0 !important;
    line-height: normal !important;
    transform: none;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs button.mat-icon-button,
  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs button.mat-mdc-icon-button {
    width: 48px;
    min-width: 48px;
    height: 48px;
    min-height: 48px;
    padding: 0;
  }

  :host ::ng-deep .edit-invoicegroup-popup .pending-time-inputs button .mat-icon {
    top: 0 !important;
    margin: 0;
    transform: none;
    font-size: 22px;
    line-height: 22px;
  }

  @media (max-width: 991.98px) {
    .edit-invoicegroup-popup .tax-row {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 767.98px) {
    .edit-invoicegroup-popup .worked-hours-top-fields {
      grid-template-columns: 1fr;
    }

    .edit-invoicegroup-popup .worked-hours-top-fields .second-row {
      grid-column: auto;
    }

    .edit-invoicegroup-popup .pending-time-row {
      align-items: flex-start;
      padding: 8px 4px;
    }

    .edit-invoicegroup-popup .pending-time-date {
      width: 100%;
    }
  }
</style>


<!--<h1 mat-dialog-title *ngIf="!isNewCustomer" style="margin-top: 5px;margin-bottom: 35px;">Redigera kund</h1>-->

<div mat-dialog-content class="edit-invoicegroup-popup">
  <form #personForm="ngForm" novalidate>


    <div class="row description-row" *ngIf="shouldShowDescriptionFields()">
      <mat-form-field floatLabel="always" appearance="fill" style="width:100%;">
        <mat-label>Beskriv ditt arbete</mat-label>
        <textarea matInput [disabled]="!canEditGeneralFields()" [ngModel]="data.invoiceItemGroup.Description" (ngModelChange)="data.invoiceItemGroup.Description = $event; quickRowValidate()" required md-maxlength="500" rows="3" placeholder="Beskrivning av utfört arbete" id="message" name="description-quick-add" md-select-on-focus></textarea>
      </mat-form-field>
      <!--<mat-form-field class="col-sm-12">
        <textarea matInput autofocus placeholder="Beskriv ditt arbete, denna information inkluderas på fakturan" [(ngModel)]="data.invoiceItemGroup.Description" ngDefaultControl [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>-->
    </div>
    <div class="worked-hours-top-fields" *ngIf="isWorkedHoursGroup()">
    <div class="row working-title-row" *ngIf="!isInvoiceItemGroup()" [ngClass]="{'half-width-top-field': isWorkedHoursGroup()}">
  <h5>Befattning/titel/yrke *</h5>
  <div class="working-title-field">
    <input matInput
           type="text"
           class="text-input full-width"
           [(ngModel)]="data.invoiceItemGroup.WorkingTitle"
           (ngModelChange)="updateValidationState()"
           placeholder="Ange din befattning/titel/yrke vid utfört arbete"
           [ngModelOptions]="{ standalone: true }"
           maxlength="200"
           [disabled]="!canEditGroup()"
           [required]="true">
  </div>
  <div class="error-message working-title-inline-error" *ngIf="!isInvoiceItemGroup() && isWorkingTitleRequired() && (!data.invoiceItemGroup.WorkingTitle || data.invoiceItemGroup.WorkingTitle.trim() === '')" style="color:red;">
    Befattning/titel/yrke är obligatoriskt.
  </div>
</div>
<div class="row" *ngIf="isWorkedHoursGroup()" [ngClass]="{'half-width-top-field': isWorkedHoursGroup()}" style="margin: 0 0 15px 0;">
      <h5>Land där arbetet utförs:</h5>
      <mat-select [disabled]="!canEditGroup()"
                  placeholder="Ange vilket land arbetet utförs i"
                  class="select-hours"
                  [(ngModel)]="workCountry"
                  name="workCountry"
                  [ngModelOptions]="{standalone: true}">
        <mat-option *ngFor="let country of countries" [value]="country?.Name">{{country?.Name}}</mat-option>
        <mat-option *ngIf="(!countries || countries.length === 0) && !!workCountry" [value]="workCountry">{{workCountry}}</mat-option>
        <mat-option *ngIf="(!countries || countries.length === 0) && !workCountry" value="Sverige">Sverige</mat-option>
      </mat-select>
    </div>

    <div *ngIf="!isInvoiceItemGroup() && timeReportStatusesLoaded && data.invoiceItemGroup.TimeReportStatus" class="row" [ngClass]="{'half-width-top-field': isWorkedHoursGroup(), 'second-row': isWorkedHoursGroup()}" style="margin: 0 0 15px 0;">
      <h5>Visa på faktura:</h5>
      <mat-select [disabled]="!canEditGroup()" placeholder="Tid på fakturan" class="select-hours select-time-report-status" [(ngModel)]="data.invoiceItemGroup.TimeReportStatus.Id" (selectionChange)="timeReportStatusChange($event)" name="timeReportStatus" ngDefaultControl [ngModelOptions]="{standalone: true}">
        <mat-option *ngFor="let item of timeReportStatuses" value="{{item?.Id}}">{{item?.DisplayName}}</mat-option>
      </mat-select>
    </div>
    </div>

    <div class="financial-fields" *ngIf="shouldShowFinancialFields()">

      <div class="financial-field">
        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>Belopp (kr)</mat-label>
          <input matInput type="number" [disabled]="!canEditGeneralFields()" [(ngModel)]="data.invoiceItemGroup.Amount" [ngModelOptions]="{ standalone: true }">
        </mat-form-field>
      </div>


      <div *ngIf="customerIsSweden && !isAdmin" class="financial-field vat-col">
        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>Momssats</mat-label>
          <mat-select [disabled]="!canEditGeneralFields()" [(ngModel)]="data.invoiceItemGroup.Vat" name="vat" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let item of vatList" value="{{item?.Value}}">{{item?.Value}} %</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="!customerIsSweden || isAdmin" class="financial-field vat-col">
        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>Momssats</mat-label>
          <mat-select [disabled]="!canEditGeneralFields()" [(ngModel)]="data.invoiceItemGroup.Vat" name="vat" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let item of vatList" value="{{item?.Value}}">{{item?.Value}} %</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-5 reverse-tax-col" style="margin-bottom: 15px; font-size: 80%;">
        <mat-checkbox matInput *ngIf="isReverseTaxAllowed()" [disabled]="!canEditGeneralFields()" [(ngModel)]="data.invoiceItemGroup.ReverseTax" (change)="reverseTaxChange(data.invoiceItemGroup, $event);setVatList()" [ngModelOptions]="{standalone: true}">
          Omvänd skattskyldighet/byggmoms
        </mat-checkbox>
      </div>
    </div>
    
    <div class="row tax-row" *ngIf="isWorkedHoursGroup()">
      <div class="col-sm-6 calendar-wrapper">
        <mat-calendar class="fixed-calendar" [selected]="selectedDates" (selectedChange)="calendarSelect($event)" #datepicker ngDefaultControl></mat-calendar>
      </div>
      <div class="col-sm-6">
        <div *ngFor="let i of data.invoiceItemGroup.InvoiceRows" class="pending-time-row">
          <div class="pending-time-date">{{i.StartDate | swedishDate: 'yyyy-MM-dd'}}</div>
          <div class="pending-time-inputs">
            <mat-form-field appearance="outline" class="time-select">
              <mat-select [disabled]="!canEditGroup() && i.Id > 0" [(ngModel)]="i.HoursWorked" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let item of hoursList" [value]="item?.Value">{{item?.Value}} h</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="time-select">
              <mat-select [disabled]="!canEditGroup() && i.Id > 0" [(ngModel)]="i.MinutesWorked" name="minutesworked" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let item of minutesList" [value]="item?.Value">{{item?.Value}} min</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button *ngIf="canEditGroup() || i.Id.length > 20" (click)="deleteListItem(i)" aria-label="Ta bort rad">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="shouldShowMiscSection()">
      <div class="row">
        <div class="col-sm-6">
          <h5>Belopp (kr)</h5>
          <input matInput class="text-input" type="number" [(ngModel)]="data.invoiceItemGroup.Amount" ngDefaultControl [ngModelOptions]="{standalone: true}">
        </div>
        <div class="col-sm-6">
          <h5>Momssats</h5>
          <mat-select placeholder="Moms" class="select-vat" [(ngModel)]="data.invoiceItemGroup.Vat" name="rowvatselected">
            <mat-option *ngFor="let item of vatList" value="{{item?.Value}}">{{item?.Value}}</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="row" style="margin-top:25px;margin-bottom:25px;">
        <div class="col-sm-12">
          <mat-form-field floatLabel="always" appearance="outline" style="width:100%;">
            <mat-label>Beskrivning</mat-label>
            <textarea matInput
                      [ngModel]="data.invoiceItemGroup.Description"
                      (ngModelChange)="data.invoiceItemGroup.Description = $event"
                      required
                      md-maxlength="1000"
                      rows="5"
                      placeholder="Beskrivning"
                      id="description"
                      name="description"
                      ngDefaultControl
                      [ngModelOptions]="{standalone: true}"
                      md-select-on-focus></textarea>
          </mat-form-field>
        </div>
      </div>

    </div>
  </form>

  <div class="row actions-row">
    <div class="col-lg-12">
      <button mat-stroked-button *ngIf="canEditGroup()" align="left" color="secondary" (click)="deleteRow()">Radera</button>
      <button mat-stroked-button *ngIf="canEditGroup()" (click)="cancel()">Avbryt</button> <!-- *ngIf="!data.invoiceItemGroup.isNew"-->
      <button type="button" mat-raised-button [disabled]="isSaving || !canSave || !canEditGroup()" [class.save-button-disabled]="isSaving || saveSubmitted" [attr.aria-disabled]="isSaving || saveSubmitted" color="accent" (click)="saveRow($event)">{{ isSaving ? 'Sparar...' : 'Spara' }}</button>

    </div>
  </div>

  <div class="row dialog-actions-row">
    <div class="col-lg-12" style="color:red; margin-top:8px;">
      <span class="error-message">{{ErrorMessageSend}}</span>
    </div>
  </div>
</div>
